function getCarYears() {
    const firstCol = Array.from(new Set(vehicleTable.map(row => row[0])));
    // const firstCol = [...new Set(vehicleTable.map(row => row[0]))];
    return firstCol;
}
function getCarMakes(year) {
  const secondCol = [...new Set(vehicleTable.filter(row => row[0] == year).map(row => row[1]))];
  return secondCol;
}
function getCarModels(year, make) {
  const threeCols = [...new Set(vehicleTable.filter(row => row[0] == year && row[1] == make ).map(row => row[2]))];
  return threeCols
}
function getCarTrims(year, make, model) {
  const fourCols = [...new Set(vehicleTable.filter(row => row[0] == year && row[1] == make && row[2] == model ).map(row => row[3]))];
  return fourCols
}

$(document).ready(function() {
  const SELECT_YEAR = 'Select Year',
        SELECT_MAKE = 'Select Make',
        SELECT_MODEL = 'Select Model';
        SELECT_TRIM = 'Select Trim';

  $('.search-vehicle').each(function() {
    var
      $yearSelect = $('#vehicle-year', this),
      $makeSelect = $('#vehicle-make', this),
      $modelSelect = $('#vehicle-model', this),
      $trimSelect = $('#vehicle-trim', this),
      $searchButton = $('.usabutton--search', this);


    $yearSelect.niceSelect();
    $makeSelect.niceSelect();
    $modelSelect.niceSelect();
    $trimSelect.niceSelect();

    $makeSelect.prop( "disabled", true ).niceSelect('update');
    $modelSelect.prop( "disabled", true ).niceSelect('update');
    $trimSelect.prop( "disabled", true ).niceSelect('update');


    $searchButton.prop( "disabled", true );

    function makeActive($el) {
      $yearSelect.parent().removeClass('active');
      $makeSelect.parent().removeClass('active');
      $modelSelect.parent().removeClass('active');
      $trimSelect.parent().removeClass('active');
      $el.parent().addClass('active');
    }

    var data = getCarYears();
    fillDataForSelect($yearSelect, data, SELECT_YEAR);
    $yearSelect.prop( "disabled", false ).niceSelect('update');
    makeActive($yearSelect);

    $yearSelect.on('change', function() {
      $modelSelect.prop( "disabled", true ).niceSelect('update');
      $searchButton.prop( "disabled", true ).niceSelect('update');
      fillDataForSelect($modelSelect, [], SELECT_MODEL);
      if ($yearSelect.val()) {
        var data = getCarMakes($yearSelect.val());
        fillDataForSelect($makeSelect, data, SELECT_MAKE);
        $makeSelect.prop( "disabled", false ).niceSelect('update');
        makeActive($makeSelect);
      } else {
        $makeSelect.prop( "disabled", true ).niceSelect('update');
        makeActive($yearSelect);
      }
    });
    $makeSelect.on('change', function() {
      $searchButton.prop( "disabled", true );
      if ($makeSelect.val()) {
        var data = getCarModels($yearSelect.val(), $makeSelect.val());
        fillDataForSelect($modelSelect, data, SELECT_MODEL);
        $modelSelect.prop( "disabled", false ).niceSelect('update');
        makeActive($modelSelect);
      } else {
        $modelSelect.prop( "disabled", true ).niceSelect('update');
        makeActive($makeSelect);
      }
    });
    $modelSelect.on('change', function() {
      $searchButton.prop( "disabled", true );
      if ($modelSelect.val()) {
        var data = getCarTrims($yearSelect.val(), $makeSelect.val(), $modelSelect.val());
        fillDataForSelect($trimSelect, data, SELECT_TRIM);
        $trimSelect.prop( "disabled", false ).niceSelect('update');
        makeActive($trimSelect);
        if (data.length == 1) {
          $trimSelect.val(data[0]).niceSelect('update');
          $trimSelect.trigger('change');
        }
      } else {
        $trimSelect.prop( "disabled", true ).niceSelect('update');
        makeActive($modelSelect);
      }
    });
    $trimSelect.on('change', function() {
      if ($trimSelect.val()) {
        $searchButton.prop( "disabled", false );
        $searchButton.trigger('click');
      } else {
        $searchButton.prop( "disabled", true );
      }
    });
    $searchButton.on('click', function(e) {
      e.preventDefault();
      var url = buildSearchUrl('all', $yearSelect.val(), $makeSelect.val(), $modelSelect.val(), $trimSelect.val());
      window.location.href = url;
    });
  });


  function buildSearchUrl(type, year, make, model, trim) {
    return '/collections/' + type + '/' + '?car=' + year + '/' + make + '/' + model + '/' + trim;
  }
  function fillDataForSelect($select, data, label) {
    $select.empty();
    $select.append($('<option>', {
        value: "",
        text : label
    }));
    $.each(data, function (i, item) {
      $select.append($('<option>', {
           value: item,
           text : item
       }));
    });
  }
});